import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "@/lib/utils";
import { FaCheck, FaMinus } from "react-icons/fa";

const checkboxVariantStyles = {
  default:
    "dark:border-muted data-[state=checked]:bg-azure data-[state=checked]:text-primary-foreground data-[state=unchecked]:border-2 disabled:opacity-50 data-[state=indeterminate]:bg-azure data-[state=indeterminate]:text-primary-foreground",
  alternative:
    "dark:border-muted data-[state=checked]:bg-azure data-[state=checked]:text-primary-foreground data-[state=unchecked]:border-2 data-[state=unchecked]:bg-white data-[state=unchecked]:text-primary disabled:opacity-100 disabled:cursor-pointer",
};

export type CheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> & {
  variant?: keyof typeof checkboxVariantStyles;
};

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, variant = "default", ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-5 w-5 shrink-0 rounded-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed",
      checkboxVariantStyles[variant],
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current p-1")}
    >
      {props.checked === "indeterminate" ? (
        <FaMinus className="h-full w-full" />
      ) : (
        <FaCheck className="h-full w-full" />
      )}
    </CheckboxPrimitive.Indicator>

    {variant === "alternative" && (
      <FaMinus className="h-full w-full p-1 text-current data-[state=checked]:hidden data-[state=indeterminate]:hidden" />
    )}
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
